import React from 'react';
import { Alert, Box, CircularProgress, Container, Paper, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { AuthAPI } from '../api/auth';
import { ROUTES } from '../routes';

export default function DemoExplorerPage() {
  const navigate = useNavigate();
  const auth = useAuth();
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    let isMounted = true;

    const startDemo = async () => {
      try {
        const res = await AuthAPI.demoLogin();
        auth.setSession(res?.data || {});
        navigate(ROUTES.ENTERPRISE, { replace: true });
      } catch (err) {
        if (!isMounted) return;
        const message = err?.response?.data?.message || 'Unable to start demo explorer session';
        setError(message);
      }
    };

    startDemo();
    return () => {
      isMounted = false;
    };
  }, [auth, navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#F8FAFC', px: 2 }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: 4, border: '1px solid #E2E8F0', borderRadius: 2 }} elevation={0}>
          <Stack spacing={2} alignItems="center">
            <CircularProgress size={28} />
            <Typography variant="h6" fontWeight={700}>
              Starting Demo Explorer
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Setting up a 30-minute demo session. Changes are blocked from saving.
            </Typography>
            {error ? <Alert severity="error" sx={{ width: '100%' }}>{error}</Alert> : null}
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}
